import jqRequest from '../jqRequest'
import liveUrls from '../urls/live'

export default {
  // 获取直播间详细信息
  getLiveRoomInfoById(data){
    return jqRequest.requestWithToken(liveUrls.getLiveRoomInfoById,data);
  },
  // 获取直播间图文互动
  getListGuestReviewById(data){
    return jqRequest.requestWithToken(liveUrls.listGuestReviewByLiveroomid,data);
  },
  // 获取直播间参与人数
  getOnAirLiveRoomPartData(data){
    return jqRequest.requestWithToken(liveUrls.getOnAirLiveRoomPartData,data,'get');
  },
}